import ufeApi from 'services/api/ufeApi';
import Crypto from 'utils/Crypto';
import lithiumApi from 'services/api/thirdparty/Lithium';
import GalleryConstants from 'utils/GalleryConstants';
import store from 'store/Store';

const { khorosInteractions } = GalleryConstants;

function getSecretKey() {
    return store.getState().user?.pixleeSecretKey;
}

function setLoveMedia(assetId, email = '') {
    const secretKey = getSecretKey();

    if (!secretKey) {
        return Promise.reject(new Error('Pixlee secret key is not available'));
    }

    // eslint-disable-next-line camelcase
    const payload = JSON.stringify({ distinct_user_hash: email });

    return Crypto.createHmacSha1(secretKey, payload).then(signature => {
        const url = new URL(`https://distillery.pixlee.co/api/v2/media/${assetId}/vote`);
        url.searchParams.append('api_key', Sephora.configurationSettings.pixleeApiKey);
        lithiumApi.incrementUserScoreForPixlee(khorosInteractions.LOVES_GIVEN, 1);
        const headers = {
            'Content-Type': 'application/json',
            Signature: signature
        };

        return ufeApi.makeRequest(url.href, {
            method: 'POST',
            headers,
            body: payload
        });
    });
}

function deleteLoveMedia(email = '', assetId) {
    const secretKey = getSecretKey();

    if (!secretKey) {
        return Promise.reject(new Error('Pixlee secret key is not available'));
    }

    // eslint-disable-next-line camelcase
    const payload = JSON.stringify({ distinct_user_hash: email });

    return Crypto.createHmacSha1(secretKey, payload).then(signature => {
        const url = new URL(`https://distillery.pixlee.co/api/v2/media/${assetId}/vote`);
        url.searchParams.append('api_key', Sephora.configurationSettings.pixleeApiKey);

        const headers = {
            'Content-Type': 'application/json',
            Signature: signature
        };

        return ufeApi.makeRequest(url.href, { method: 'DELETE', headers, body: payload });
    });
}

function deleteContent(email = '', assetId) {
    const secretKey = getSecretKey();

    if (!secretKey) {
        return Promise.reject(new Error('Pixlee secret key is not available'));
    }

    // eslint-disable-next-line camelcase
    const payload = JSON.stringify({ distinct_user_hash: email });

    return Crypto.createHmacSha1(secretKey, payload).then(signature => {
        const url = new URL(`https://distillery.pixlee.co/api/v2/media/${assetId}/deny`);
        url.searchParams.append('api_key', Sephora.configurationSettings.pixleeApiKey);

        const headers = {
            'Content-Type': 'application/json',
            Signature: signature
        };

        return ufeApi.makeRequest(url.href, {
            method: 'POST',
            headers,
            body: payload
        });
    });
}

export default {
    setLoveMedia,
    deleteLoveMedia,
    deleteContent
};
